import React, { useEffect, useState } from 'react';
import { AiOutlineArrowRight } from 'react-icons/ai';
import { emailRegex } from '~/utils/regex'
import { ReactComponent as IconSuccess } from "~/assets/icons/icon-success.svg";

import {
  Container,
  Header,
  Left,
  Title,
  CloseIcon,
  Content,
  InputEmail,
  IconEmail,
  SubTitle,
  ButtonNext,
  SuccessContainer,
  IconSuccessContainer,
  SuccessMsg,
} from './styles';

function ModalContent({
  email,
  setEmail,
  close,
  sendMail,
  isLoading,
  setMailSuccess,
  mailSuccess,
  originUnique,
  clearSelected,
}) {
  const [error, setError] = useState(false);
  const [changedEmail, setChangedEmail] = useState(false);

  useEffect(() => {
    if(!email) return setError(false);
    setError(!emailRegex.test(email));
  }, [email])

  useEffect(() => {
    if(email || changedEmail) return;
    const emailStorage = localStorage.getItem('@UltragazEmpresarial:loginEmail');
    setEmail(emailStorage);
  }, [email, changedEmail])

    return (
      <Container>
        <Header>
        <Left>
          {(!mailSuccess || (mailSuccess && isLoading)) && (
            <>
              <Title>Informe o email</Title>
              <SubTitle>Para qual email deseja enviar o(s) arquivo(s).</SubTitle>
            </>
          )}
          </Left>
          <CloseIcon
            style={{
              marginTop: '-30px'
            }}
            title="Fechar"
            className="mdi mdi-close"
            onClick={() => {
              if(originUnique) {
                clearSelected();
              }
              setMailSuccess(false);
              close();
            }}
          />
        </Header>
        <Content>
          {(!mailSuccess || (mailSuccess && isLoading)) && (
            <>
              <InputEmail
                labelText="Insira seu email*"
                inputType="text"
                inputName="email"
                inputId="email"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  setChangedEmail(true);
                }}
                icon={IconEmail}
                msgError={(error) ? 'Forneça um email válido' : ''}
              />
              <ButtonNext
                buttonType={(email && !error && !isLoading) ? "primary" : "disabled"}
                disabled={!email || error || isLoading}
                iconRight={AiOutlineArrowRight}
                onClick={sendMail}
              >
                {isLoading ? 'Aguarde...' : 'Enviar'}
              </ButtonNext>
            </>
          )}
          {mailSuccess && !isLoading && (
            <>
              <SuccessContainer>
                <IconSuccessContainer>
                  <IconSuccess />
                </IconSuccessContainer>
                <SuccessMsg>
                  Arquivo(s) enviado(s) com sucesso!
                </SuccessMsg>
              </SuccessContainer>
              <ButtonNext
                onClick={() => {
                  if(originUnique) {
                    clearSelected();
                  }
                  setMailSuccess(false);
                  close();
                }}
              >
                OK
              </ButtonNext>
            </>
          )}
        </Content>
      </Container>
    );
}

export default ModalContent;
